class LazyScroll {
    constructor(options = {}) {
     }
  }
  
  export default LazyScroll;